const React = require('react');
const { render } = require('react-dom');
const { createStore } = require('redux');
const { Provider } = require('react-redux');
const { DndProvider } = require('react-dnd');
const { HTML5Backend } = require('react-dnd-html5-backend');
const { TouchBackend } = require('react-dnd-touch-backend');
const { reducer } = require('./reducers').default;
const Application = require('./applications').default;

// ==========================================

const rootElement = document.getElementById('root');
const store = createStore(reducer);

function isAndroid() {
    return !!window.navigator.userAgent.match(/Android/);
}

function isIOS() {
    return !!window.navigator.userAgent.match(/iPhone|iPad|iPod/);
}

render(
    <DndProvider backend={(isAndroid() || isIOS()) ? TouchBackend : HTML5Backend}>
        <Provider store={store}>
            <Application />
        </Provider>
    </DndProvider>,
    rootElement
)
